import { render, staticRenderFns } from "./ButtonTableComponent.vue?vue&type=template&id=726a7632"
import script from "./ButtonTableComponent.vue?vue&type=script&lang=js"
export * from "./ButtonTableComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports